export type IssueOrderFields = {
  id: string;
  publication: string;
  issue_date: string | null;
  issue_label?: string;
};

function issueNumber(issue: IssueOrderFields): number | null {
  const match = issue.issue_label?.match(/(\d{4})年第\s*(\d+)\s*期/u);
  return match ? Number(match[1]) * 1000 + Number(match[2]) : null;
}

export function comparePublicationIssues(left: IssueOrderFields, right: IssueOrderFields): number {
  const leftNumber = issueNumber(left);
  const rightNumber = issueNumber(right);
  if (leftNumber !== null && rightNumber !== null) return rightNumber - leftNumber;
  return (right.issue_date ?? "").localeCompare(left.issue_date ?? "");
}

export function sortIssues<T extends IssueOrderFields>(issues: readonly T[]): T[] {
  const chronological = [...issues].sort((left, right) =>
    (right.issue_date ?? "").localeCompare(left.issue_date ?? ""));
  const publications = new Map<string, T[]>();
  for (const issue of chronological) {
    const group = publications.get(issue.publication) ?? [];
    group.push(issue);
    publications.set(issue.publication, group);
  }
  for (const group of publications.values()) group.sort(comparePublicationIssues);
  // A late import must not put an older issue ahead of a newer issue of the
  // same publication. Preserve the chronological slots of other publications.
  const offsets = new Map<string, number>();
  return chronological.map((issue) => {
    const offset = offsets.get(issue.publication) ?? 0;
    offsets.set(issue.publication, offset + 1);
    return publications.get(issue.publication)![offset]!;
  });
}
